import React, { createContext, useState, useContext, useEffect } from 'react';
import { amigosService } from '../services/amigosService';
import { useAuth } from './auth';

const FriendRequestsContext = createContext({});

export const FriendRequestsProvider = ({ children }) => {
  const [pendingRequests, setPendingRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, signed } = useAuth();

  const fetchPendingRequests = async () => {
    if (!signed || !user?.id) return;
    
    try {
      setLoading(true);
      const { solicitacoes } = await amigosService.listarSolicitacoesAmizade(user.id);
      setPendingRequests(solicitacoes || []);
    } catch (error) {
      console.error('Erro ao buscar solicitações de amizade:', error);
    } finally {
      setLoading(false);
    }
  };

  // Buscar solicitações ao carregar o componente
  useEffect(() => {
    if (signed) {
      fetchPendingRequests();
    }
  }, [signed, user?.id]);

  // Função para aceitar solicitação
  const acceptRequest = async (solicitacaoId) => {
    try {
      await amigosService.aceitarSolicitacaoAmizade(user.id, solicitacaoId);
      // Atualizar a lista removendo a solicitação aceita
      setPendingRequests(pendingRequests.filter(req => req.id !== solicitacaoId));
      return true;
    } catch (error) {
      console.error('Erro ao aceitar solicitação:', error);
      return false;
    }
  };

  // Função para rejeitar solicitação
  const rejectRequest = async (solicitacaoId) => {
    try {
      await amigosService.rejeitarSolicitacaoAmizade(user.id, solicitacaoId);
      // Atualizar a lista removendo a solicitação rejeitada
      setPendingRequests(pendingRequests.filter(req => req.id !== solicitacaoId));
      return true;
    } catch (error) {
      console.error('Erro ao rejeitar solicitação:', error);
      return false;
    }
  };

  return (
    <FriendRequestsContext.Provider value={{
      pendingRequests,
      pendingCount: pendingRequests.length,
      loading,
      fetchPendingRequests,
      acceptRequest,
      rejectRequest
    }}>
      {children}
    </FriendRequestsContext.Provider>
  );
};

export function useFriendRequests() {
  const context = useContext(FriendRequestsContext);
  if (!context) {
    throw new Error('useFriendRequests deve ser usado dentro de um FriendRequestsProvider');
  }
  return context;
}
